module.exports = __webpack_public_path__ + "img/ai@2x.a27aa6e6.png";